import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';
import Utils from '../../../util';
import { Unit, UnitService } from '../../anessa-library/anessa-library/projects/unit-library/src/public-api';
import { InputSummary } from '../../../models/input-summary';
import { AnessaTranslationInterface } from '../../../models/interfaces/anessa-translation.interface';
import { AnessaTranslationService } from '../../translation/anessa-translation.service';
import { UserpilotReloader } from '../../userpilot-reloader.component';

@Component({
  selector: 'app-input-summary-subtable',
  templateUrl: './input-summary-subtable.component.html',
  styleUrls: ['./input-summary-subtable.component.scss']
})
export class InputSummarySubtableComponent extends UserpilotReloader implements OnInit, OnDestroy, AnessaTranslationInterface {
  @Input() subtable: InputSummary;
  @Input() sectionTitle: string;
  @Input() level: number;

  onDestroyNotifier = new Subject<boolean>();

  Object = Object;
  displayedColumns: string[];
  classes = ['header-level-1', 'header-level-2', 'header-level-3', 'header-level-4', 'header-level-5'];

  trigger: string;

  nameHeader: string;
  valueHeader: string;
  unitHeader: string;

  dataCopy;

  constructor(
    private unitService: UnitService,
    private translationService: AnessaTranslationService
  ) {
    super();
  }

  ngOnInit() {
    this.setTranslations();
    this.unitService.unitsLoadedNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .pipe(takeWhile(x => !x, true))
      .subscribe(data => {
        if (data) {
          this.setTable();
        }
      });

    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.setTranslations();
        this.setTable();
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next(true);
    this.onDestroyNotifier.unsubscribe();
  }

  setTranslations() {
    this.nameHeader = this.translationService.get('INPUT_SUMMARY.TABLE_HEADERS.NAME');
    this.valueHeader = this.translationService.get('INPUT_SUMMARY.TABLE_HEADERS.VALUE');
    this.unitHeader = this.translationService.get('INPUT_SUMMARY.TABLE_HEADERS.UNIT');
    this.displayedColumns = [this.nameHeader, this.valueHeader, this.unitHeader];
  }

  setTable() {
    this.dataCopy = {};
    const units = this.unitService.getAllUnits();
    this.dataCopy = Utils.deepCopy(this.subtable);
    if (this.dataCopy['inputs']) {
      const newInputs = [];
      for (const input of this.dataCopy['inputs']) {
        const newInput = {};
        newInput[this.nameHeader] = input.name;
        newInput[this.valueHeader] = input.value;
        newInput[this.unitHeader] = input.unit;
        const unitData = units.filter(unit => unit.id === input.value).pop();
        if (unitData) {
          newInput[this.valueHeader] = unitData.translationId;
        }
        if (newInput[this.unitHeader]) {
          if (newInput[this.unitHeader] !== '') {
            const unitData = units.filter(unit => unit.id === input.unit).pop();
            if (unitData) {
              newInput[this.unitHeader] = unitData.translationId;
            }
          }
        }
        newInputs.push(newInput);
        this.dataCopy['inputs'] = newInputs;
      }
    }
  }

  showHeader() {
    if (this.dataCopy) {
      if (this.dataCopy['inputs'] && this.dataCopy['inputs'].length > 0) {
        return true;
      }
      if (this.dataCopy['subSection']) {
        return this.checkForSubData(this.dataCopy['subSection']);
      }
    }
    return false;
  }

  checkForSubData(data) {
    if (data) {
      for (const key of Object.keys(data)) {
        if (this.checkForSubData(data[key]['subSection'])) {
          return true;
        }
        if (data[key]['inputs'] && data[key]['inputs'].length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  // checks if string contains a dot separator before translating
  processStringForTranslations(string: string) {
    return Unit.parseUnitDisplayName(this.translationService.get(string));
  }
}
